import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f38b9af6&scoped=true"
import script from "@/components/common/BookDemo/index.js?vue&type=script&lang=js&external"
export * from "@/components/common/BookDemo/index.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=f38b9af6&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=f38b9af6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38b9af6",
  null
  
)

export default component.exports